import { Link } from 'react-router-dom';

export default function AboutCTA() {
  return (
    <section className="py-32 px-8 bg-[#0E1A2B]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-5xl md:text-6xl font-light text-white mb-12 tracking-tight leading-tight">
          Build Intelligence Into Your Operations
        </h2>
        <Link
          to="/solutions#audit"
          className="inline-block bg-white text-[#0E1A2B] px-12 py-4 rounded-full text-lg font-medium hover:bg-[#F5F5F7] transition-all whitespace-nowrap cursor-pointer"
        >
          Schedule a Strategy Session
        </Link>
      </div>
    </section>
  );
}